<mat-sidenav-container class="sidenav-container">
  <mat-sidenav #sidenav mode="over" class="sidenav">
    <app-sidebar [loggedUser]="loggedUser$ | async" (toggleSidenav)="sidenav.toggle()" (logout)="onLogout()" [selectedLanguage]="selectedLanguage" (setSelectedLanguage)="setSelectedLanguage($event)">
    </app-sidebar>
  </mat-sidenav>
  <mat-sidenav-content class="sidenav-content">
    <app-header *ngIf="layoutState$ | async as layoutState" [isMain]="layoutState.isMain" [title]="layoutState.title"
      [commands]="layoutState.commands" (backClicked)="back()" (menuClicked)="sidenav.toggle()"
      [showNotifications]="(loggedUser$ | async)?.role != roles.SuperAdmin && (loggedUser$ | async)?.role != roles.MedicalConsultant"
      [notifications]="documentNotifications$|async" (setNotificationAsRead)="onSetNotificationAsRead($event)">
    </app-header>
    <div id="ptr-content" class="content flex-grow-1 d-flex overflow-hidden">
      <router-outlet></router-outlet>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>
